import React from 'react';
import { PASS_PRICE_MONTHLY } from '../constants/pricing';

export function MembershipPrice() {
  return (
    <div className="pass-price">
      {PASS_PRICE_MONTHLY}
      <span>/ month</span>
    </div>
  );
}

export default MembershipPrice;
